import { ICON_BASE_PATH } from "../../../utils/config";

interface DialogHeaderProps {
  handleClose: () => void;
  title?: string;
  subtitle?: string;
  showAppLogo?: boolean;
}

const DialogHeader: React.FC<DialogHeaderProps> = ({
  handleClose,
  title,
  subtitle,
  showAppLogo = false,
}) => {
  return (
    <div className="gx-dialog-box-header gx-dialog-header-sec-1">
      <div className="gx-dialog-title-h2">
        {showAppLogo === true ? (
          <img
            className="!h-[30px]"
            src={`${ICON_BASE_PATH}grow_x_logo_black.svg`}
            alt="Close"
          />
        ) : (
          <h2 className="gx-h2-26-l">
            {title}
            <span className="gx-h2-26-b">{subtitle}</span>
          </h2>
        )}
      </div>
      <button className="gx-dialog-close-button" onClick={handleClose}>
        <img
          className="gx-icon-primary"
          src={`${ICON_BASE_PATH}close.svg`}
          alt="Close"
        />
      </button>
    </div>
  );
};

export default DialogHeader;
